// extracted by mini-css-extract-plugin
export default {"pageLayout":"qtsVmphZ","section":"HJ6sPrgf","heading":"iq_f77Vo","subheading":"kLxEN96d","counters":"A30wQbNg","counterSubtext":"qifSn5Sm","countersContainer":"LxKDGz79"};